// extracted by mini-css-extract-plugin
module.exports = {"new":"new__y9Q66","in-progress":"in-progress__Uoc-U","complete":"complete__2ob3M","error":"error__1eO23","checkbox":"checkbox__3ApHX"};